// DispatchBoardLogic.js
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { getDate, localToUTCDate } from "components/formatDate";

/**
 * Fetch all ServiceRequests, then filter to entityType === 'WorkOrder'
 */
export const getServiceRequests = async (navigate) => {
  const token = getToken();
  
  if (!token) {
    navigate('/login')
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/ServiceRequest/getServiceRequest/0/0`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching service requests");
  }

  // only keep WorkOrder records
  return data?.result || [];
};

/**
 * Fetch all WorkRequirements
 */
export const getWorkRequirements = async (navigate) => {
  const token = getToken();
  

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }
  const res = await fetch(
    `${dev_baseUrl}/WorkRequirement/get?workReqID=0&entityID=0`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching work requirements");
  }

  return data?.result || [];
};

export const getServices = async (navigate) => {
  const token = getToken();

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/Service/get?ServiceOfferingID=0`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching services");
  }

  return data?.result || [];
};


export const getBudgetedSummaries = async (navigate) => {
  const token = getToken();
  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }

  const res = await fetch(
    `${dev_baseUrl}/Job/getBudgetedSummary?requestID=0&workReqID=0`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching budget summaries");
  }

  return data?.result || [];
};

export const uploadAttachment = async (requestID, file, entityType = "Request") => {
  const token = getToken();
  if (!token) throw new Error("No access token for media upload");

  const form = new FormData();
  form.append("EntityType", entityType);
  form.append("EntityID",   requestID);
  form.append("MediaType",  "Attachment");
  form.append("file",       file);

  const res  = await fetch(`${dev_baseUrl}/Media/upload`, {
    method:  "POST",
    headers: { Authorization: `Bearer ${token}` },
    body:    form
  });
  const data = await res.json();

  if (!res.ok || data.isError) {
    throw new Error(data.message || "Attachment upload failed");
  }
  return data;
}

export const getAttachments = async (entityID) => {
  const token = getToken()
  const res = await fetch(`${dev_baseUrl}/Media/getmedia/Attachment/Request/${entityID}/0`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  const data = await res.json()
  if (!res.ok || data.isError) {
    throw new Error(data.message || "Getting Attachment failed");
  }
  return data.result || []
}

export const deleteAttachmentAPI = async (requestID, mediaID) => {
  const token = getToken();
  const res = await fetch(
    `${dev_baseUrl}/Media/delete/Attachment/Request/${requestID}/${mediaID}`,
    { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }
  );
  const data = await res.json();
  if (!res.ok || data.isError) {
    throw new Error(data.message || 'Failed to delete attachment');
  }
}

export const SaveServiceRequest = async (serviceRequest,navigate,entityType = 'Request') => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
          // console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/saveServiceRequest`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceRequest),
      });
        
      const data = await response.json();
      
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};


export const getJobWorkRequirement = async (workReqID,navigate) => {
  const token = getToken();
  

  if (!token) {
    navigate('/login');
    throw new Error("No access token");
  }
  const res = await fetch(
    `${dev_baseUrl}/WorkRequirement/get?workReqID=${workReqID}&entityID=0`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const data = await res.json();
  // console.log(data)

  if (!res.ok || data.isError || !Array.isArray(data.result)) {
    throw new Error(data.message || "Error fetching work requirements");
  }

  return data?.result || [];
};

export const getJobs2 = async (startDate, endDate, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/Job/get?fromDate=${startDate}T00:00:00&toDate=${endDate}T23:59:59`,
        {
          method: "GET",
          headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
        }
      );
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }

    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};
export const getAssests = async (startDate, endDate, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/JobAsset/get?fromDate=${startDate}T00:00:00&toDate=${endDate}T23:59:59`,
        {
          method: "GET",
          headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
        }
      );
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }

    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};
export const getLabors = async (startDate, endDate, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/JobLabor/get?fromDate=${startDate}T00:00:00&toDate=${endDate}T23:59:59`,
        {
          method: "GET",
          headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
        }
      );
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }

    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};
export const getJobs = async (date, navigate, jobsiteID = 0) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const formatted= getDate(date);
      const response = await fetch(
        `${dev_baseUrl}/Jobsite/getJobsiteData/${jobsiteID}/${formatted}`,
        {
          method: "GET",
          headers: { 'Authorization': `Bearer ${accesstoken}`, 'Content-Type': 'application/json' },
        }
      );
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }

    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};